/* [2026-09-26 성능] 기본값을 pia-fox-avatar.js 가 덮어쓰는 최종값과 같게 맞췄다.
   예전 기본값(mascot_hero_v2.webp · images/pia-bot-wave.webp)은 fox-avatar 가 곧바로 바꿔서
   화면에 남지 않는데, 그 전에 그려지면 쓰지 않을 그림을 한 번 더 받았다. */
window.PIA_BOT_HERO='/images/pia-fox-hero.webp?v=5';
window.PIA_BOT_HERO_DEFAULT='/images/pia-fox-hero.webp?v=5';
window.PIA_BOT_WAVE='/images/pia-fox.webp?v=2';

window.PIA=window.PIA||{};
/* hero(첫 화면 큰 캐릭터)는 첫 화면의 LCP 요소다.
   - loading=lazy 를 쓰면 배치가 끝난 뒤에야 받기 시작한다 → eager + fetchpriority=high
   - 크기 속성이 없으면 그림이 도착할 때 아래 내용이 밀린다(CLS) → width/height 로 비율만 알려 준다.
     실제 표시 크기는 CSS(width:100%/height:auto 등)가 정하고, 그림이 오면 그림의 실제 비율을 쓴다.
   wave(결과 화면 캐릭터)는 여우(pia-fox.webp 220×220)·결과 캐릭터(pia-char-NN 320×320) 모두 정사각형이다. */
window.PIA.botImg=function(kind,alt){
  var hero=(kind!=='wave');
  var src=hero?window.PIA_BOT_HERO:window.PIA_BOT_WAVE;
  var size=hero?' width="876" height="1237"':' width="220" height="220"';
  var load=hero?' loading="eager" fetchpriority="high"':' loading="lazy"';
  /* [2026-09-28 성능] 휴대폰에서 hero 는 약 150px 로 그려지는데(3배 화면이면 450px) 876px 원본(123KB)을
     받았다. 480px 판(50KB)을 srcset 으로 같이 알려 휴대폰은 작은 것을, PC·키오스크는 지금처럼 원본을 받는다.
     PIA_BOT_HERO 를 다른 그림으로 바꾼 경우(기본값이 아닐 때)는 srcset 을 붙이지 않는다. */
  var set=(hero && src===window.PIA_BOT_HERO_DEFAULT)?' srcset="/images/pia-fox-hero-480.webp?v=1 480w, '+src+' 876w" sizes="(max-width: 700px) 160px, 876px"':'';
  return '<img class="pia-bot" src="'+src+'"'+set+' alt="'+(alt||'')+'"'+(alt?'':' aria-hidden="true"')+size+load+' decoding="async">';
};
